import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/municipio/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function findMunicipio(empresa_cnpj, uf, orderByColumn) {
  const filters = uf ? `&uf=${uf}` : "";

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${filters}${
      orderByColumn ? "&orderBy=" + orderByColumn : ""
    }`,
    "GET",
    headers
  );
}
